import React, { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Calendar, 
  FileText, 
  Receipt, 
  Settings,
  LogOut,
  Menu,
  X
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

function Layout() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="app-container">
      <div className="mobile-header">
        <h1 style={{ fontSize: '1.25rem', color: 'var(--accent)', margin: 0 }}>
          Physio<span style={{ color: 'white' }}>Pro</span>
        </h1>
        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <div className={`sidebar-overlay ${menuOpen ? 'open' : ''}`} onClick={closeMenu} />
      <aside className={`sidebar ${menuOpen ? 'open' : ''}`}>
        <div style={{ padding: '0 1.5rem', marginBottom: '2rem' }}>
          <h1 style={{ 
            fontSize: '1.5rem', 
            color: 'var(--accent)', 
            fontWeight: '800',
            marginBottom: '0.5rem'
          }}>
            Physio<span style={{ color: 'white' }}>Pro</span>
          </h1>
          <p style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.6)' }}>
            {user?.firstName} {user?.lastName}
          </p>
        </div>

        <nav>
          <NavLink to="/" end className="nav-item" onClick={closeMenu}>
            <LayoutDashboard size={20} />
            <span>Dashboard</span>
          </NavLink>
          
          <NavLink to="/calendar" className="nav-item" onClick={closeMenu}>
            <Calendar size={20} />
            <span>Calendar</span>
          </NavLink>
          
          <NavLink to="/appointments" className="nav-item" onClick={closeMenu}>
            <FileText size={20} />
            <span>Appointments</span>
          </NavLink>
          
          <NavLink to="/patients" className="nav-item" onClick={closeMenu}>
            <Users size={20} />
            <span>Patients</span>
          </NavLink>

          <NavLink to="/invoices" className="nav-item" onClick={closeMenu}>
            <span style={{ 
              fontSize: '0.8rem', 
              fontWeight: 700, 
              width: '20px', 
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid currentColor',
              borderRadius: '4px'
            }}>£</span>
            <span>Invoices</span>
          </NavLink>

          <div style={{ 
            borderTop: '1px solid rgba(255,255,255,0.1)', 
            margin: '1rem 0',
            marginTop: '2rem'
          }} />

          <button 
            onClick={() => { closeMenu(); logout(); }}
            className="nav-item" 
            style={{ 
              width: '100%', 
              background: 'none', 
              border: 'none',
              cursor: 'pointer',
              textAlign: 'left'
            }}
          >
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </nav>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
